import { ReactNode } from "react";

const OnBoardingContainer = ({ children }: { children: ReactNode }) => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="min-h-screen flex items-center relative flex-col bg-white">
      <div className="flex w-full h-screen">
        <div className="grid lg:grid-cols-2 items-center flex-1 w-full h-full">
          <div className="text-center lg:order-1 order-2 lg:block hidden h-full">
            <div className="flex flex-col items-start h-full relative z-10">
              <img
                src="./images/Onboarding-bg.png"
                alt=""
                className="h-screen w-full absolute"
              />
              <div className="w-full h-full z-50">
                <div className="w-full h-[95%] flex flex-col justify-center items-center leading-[77px] font-inter">
                  <h1
                    className="text-white capitalize text-[64px] font-normal"
                    style={{ letterSpacing: "2px" }}
                  >
                    AREA ACCESS
                  </h1>
                  <h1
                    className="text-white capitalize font-black text-[91px] ml-[1px]"
                    style={{ letterSpacing: "9px" }}
                  >
                    RECORD
                  </h1>
                </div>
                {/* <div className="w-full flex justify-center items-center text-white gap-x-9 relative bottom-[20px]">
                  <a href="#">Privacy Policy</a>
                  <a href="#">License</a>
                  <a href="#">Terms of Use</a>
                  <a href="#">Blog</a>
                </div> */}
              </div>
            </div>
          </div>
          <div className="2xl:px-16 xl:px-8 px-4 lg:order-2 py-12 order-1 relative z-10 flex flex-col h-full">
            <div className="flex-1 flex flex-col justify-center max-w-[350px] mx-auto w-full ">
              <img
                src="./images/ALEC-logo.png"
                alt=""
                className="self-center w-[188px] h-[89px]"
              />
              <div className="flex-1 flex flex-col justify-center items-center py-8">
                {children}
              </div>
            </div>
            <div className="flex justify-between text-base  w-full  max-w-md mx-auto ">
              <p className="text-[#A3AED0] text-[12px] mx-auto">
                © {currentYear} Area Access Record. All Rights Reserved. By ALEC
                HOLDINGS.
              </p>
            </div>
          </div>
        </div>
      </div>
      <img
        src="./images/bgBottom.png"
        alt=""
        className="absolute bottom-0 left-0 lg:max-w-max max-w-[250px]"
      />
    </div>
  );
};

export default OnBoardingContainer;
